var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherSunCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5093 41.0461C34.5093 52.7038 43.9371 62.1602 55.5596 62.1602C67.1821 62.1602 76.6099 52.7038 76.6099 41.0461C76.6099 29.3885 67.1821 19.9419 55.5596 19.9419C43.9371 19.9419 34.5093 29.3885 34.5093 41.0461Z",
    fill: "url(#paint0_radial_42_2421)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M58.7574 38.8749C53.3939 34.5119 51.2977 27.8687 54.0828 24.0388C56.858 20.2088 63.4614 20.6333 68.8249 24.9963C74.1884 29.3593 76.2747 36.0025 73.4995 39.8324C70.7144 43.6624 64.1208 43.2379 58.7574 38.8749Z",
    fill: "url(#paint1_radial_42_2421)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M36.9497 45.7156C37.6583 43.386 41.27 44.3534 45.0097 47.8773C48.7592 51.4112 51.2096 56.1591 50.5109 58.4985C49.8023 60.8281 46.1906 59.8706 42.4411 56.3368C38.7015 52.803 36.2412 48.055 36.9399 45.7156H36.9497Z",
    fill: "url(#paint2_radial_42_2421)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1085 13.694C58.1085 15.1056 56.9669 16.2506 55.5596 16.2506C54.1523 16.2506 53.0107 15.1056 53.0107 13.694V10.0615C53.0107 8.64992 54.1523 7.50488 55.5596 7.50488C56.9669 7.50488 58.1085 8.64992 58.1085 10.0615V13.694Z",
    fill: "url(#paint3_radial_42_2421)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0722 19.9031C39.0661 20.9 39.0661 22.5288 38.0722 23.5257C37.0782 24.5227 35.4642 24.5227 34.4604 23.5257L31.9017 20.9593C30.9078 19.9623 30.9078 18.3336 31.9017 17.3366C32.8957 16.3396 34.5195 16.3396 35.5134 17.3366L38.0722 19.9031Z",
    fill: "url(#paint4_radial_42_2421)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2799 38.4897C29.6872 38.4897 30.8288 39.6348 30.8288 41.0463C30.8288 42.4579 29.6872 43.6029 28.2799 43.6029H24.6583C23.251 43.6029 22.1095 42.4579 22.0996 41.0463C22.0996 39.6348 23.2412 38.4897 24.6583 38.4897H28.2799Z",
    fill: "url(#paint5_radial_42_2421)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4702 58.5773C35.4642 57.5803 37.088 57.5803 38.0819 58.5773C39.0759 59.5743 39.0759 61.1931 38.0819 62.2L35.5232 64.7664C34.5292 65.7634 32.9054 65.7634 31.9115 64.7664C30.9175 63.7695 30.9175 62.1408 31.9115 61.1438L34.4702 58.5773Z",
    fill: "url(#paint6_radial_42_2421)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.001 68.3989C53.001 66.9873 54.1426 65.8423 55.5498 65.8423C56.9571 65.8423 58.0987 66.9873 58.0987 68.3989V72.0314C58.0987 73.443 56.9571 74.588 55.5498 74.588C54.1426 74.588 53.001 73.443 53.001 72.0314V68.3989Z",
    fill: "url(#paint7_radial_42_2421)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0375 62.2C72.0435 61.203 72.0435 59.5743 73.0375 58.5773C74.0314 57.5803 75.6454 57.5803 76.6492 58.5773L79.2079 61.1438C80.2019 62.1408 80.2019 63.7695 79.2079 64.7664C78.2139 65.7634 76.5901 65.7634 75.5962 64.7664L73.0375 62.2Z",
    fill: "url(#paint8_radial_42_2421)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8199 43.6132C81.4126 43.6132 80.271 42.4682 80.271 41.0566C80.271 39.645 81.4126 38.5 82.8199 38.5H86.4414C87.8487 38.5 88.9903 39.645 89.0001 41.0566C89.0001 42.4682 87.8586 43.6132 86.4414 43.6132H82.8199Z",
    fill: "url(#paint9_radial_42_2421)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6394 23.5155C75.6455 24.5124 74.0217 24.5124 73.0277 23.5155C72.0337 22.5185 72.0337 20.8997 73.0277 19.8928L75.5864 17.3263C76.5804 16.3294 78.2042 16.3294 79.1981 17.3263C80.1921 18.3233 80.1921 19.952 79.1981 20.949L76.6394 23.5155Z",
    fill: "url(#paint10_radial_42_2421)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6341 27.0591C41.654 27.0591 52.558 36.0911 55.4907 48.2423C57.8526 47.0972 60.4999 46.426 63.3046 46.426C73.2344 46.426 81.2845 54.5005 81.2845 64.4604C81.2845 74.4202 73.2344 82.4947 63.3046 82.4947H28.6341C13.3704 82.4947 1 70.0868 1 54.7769C1 39.467 13.3704 27.0591 28.6341 27.0591Z",
    fill: "url(#paint11_radial_42_2421)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6341 27.0591C41.654 27.0591 52.558 36.0911 55.4907 48.2423C57.8526 47.0972 60.4999 46.426 63.3046 46.426C73.2344 46.426 81.2845 54.5005 81.2845 64.4604C81.2845 74.4202 73.2344 82.4947 63.3046 82.4947H28.6341C13.3704 82.4947 1 70.0868 1 54.7769C1 39.467 13.3704 27.0591 28.6341 27.0591Z",
    fill: "url(#paint12_radial_42_2421)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M25.1007 53.5531C32.2946 47.6996 35.1092 38.7762 31.3794 33.6334C27.6495 28.4906 18.7925 29.0631 11.5887 34.9166C4.39479 40.7701 1.59005 49.6935 5.31986 54.8363C9.04968 59.9791 17.9166 59.4066 25.1105 53.5531H25.1007Z",
    fill: "url(#paint13_radial_42_2421)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M61.3171 61.1634C65.2733 57.9455 66.8183 53.0396 64.7615 50.2165C62.7145 47.3835 57.8431 47.7092 53.887 50.9173C49.9308 54.1353 48.3956 59.0412 50.4426 61.8643C52.4994 64.6973 57.3708 64.3715 61.3171 61.1634Z",
    fill: "url(#paint14_radial_42_2421)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2,
    d: "M70.0849 68.1716C74.4347 63.7592 78.9223 62.0318 80.123 64.312C81.3137 66.5922 78.755 72.0213 74.4052 76.4336C70.0554 80.846 65.558 82.5734 64.3672 80.2932C63.1764 78.013 65.7351 72.5839 70.0849 68.1716Z",
    fill: "url(#paint15_radial_42_2421)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_42_2421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.3621 27.8091) rotate(180) scale(39.9553 40.0763)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_42_2421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.911 -118.643) rotate(125.948) scale(8.5874 12.4791)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_42_2421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(752.323 730.942) rotate(-136.703) scale(9.32971 3.94123)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_42_2421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.0221 8.79799) scale(6.94789 6.96894)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_42_2421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.1455 17.9036) rotate(-45.0867) scale(6.95842 6.95839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_42_2421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.3986 40.5824) rotate(-90) scale(6.96894 6.94789)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_42_2421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.4792 63.5098) rotate(-134.913) scale(6.95842 6.95839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_42_2421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.0972 73.3048) rotate(180) scale(6.94789 6.96894)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_42_2421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.9574 64.1879) rotate(134.913) scale(6.95842 6.95839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_42_2421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.7109 41.5107) rotate(90) scale(6.96894 6.94788)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_42_2421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.6167 18.5785) rotate(45.0867) scale(6.95842 6.95839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE761C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_42_2421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.2811 34.6696) rotate(180) scale(68.6227 68.8306)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D9F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89C0F5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_42_2421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.8812 40.3455) scale(42.6911 42.8205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FECE30",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FEB72B",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FEA326",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FE9322",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FE861F",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FE7D1D",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FE771C",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FE761C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_42_2421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-128.137 -161.833) rotate(54.0524) scale(11.5345 16.7617)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_42_2421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-88.057 -148.903) rotate(54.0524) scale(6.34537 9.22099)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_42_2421",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.6181 84.4034) rotate(-146.911) scale(3.8888 10.661)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherSunCloud);
export default __webpack_public_path__ + "static/media/weather-sun-cloud.0ef434832a00ccd7cfdc2d050200eee2.svg";
export { ForwardRef as ReactComponent };